import { Pagination } from "antd";
import { RefreshCw } from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { getCustomerCreditRepaymentReport } from "../../services/ReportApiService";
import {
  DatatablePagingParameter,
  Filterclass,
} from "../../core/json/DatatablePagingParameters";
import Table from "../../core/pagination/datatable";
function CustomerRepayment() {
  const [customerRepaymentData, setCustomerRepaymentData] = useState([]);
  const { branch } = useSelector((state) => state.branchlist);
  useEffect(() => {
    handleSaleReportList();
  }, [branch]);

  const handleSaleReportList = async () => {
    try {
      const DatatablePagingParameters = new DatatablePagingParameter();
      DatatablePagingParameters.PageNumber = 1;
      DatatablePagingParameters.PageSize = -1;
      const Filters = new Filterclass();
      Filters.Branch = branch;
      Filters.FromDate = dayjs().startOf("year").format("YYYY-MM-DD");
      Filters.ToDate = dayjs().format("YYYY-MM-DD");
      const response = await getCustomerCreditRepaymentReport({
        DatatablePagingParameters,
        Filters,
      });
      setCustomerRepaymentData(
        response?.data?.customerCreditRepaymentReportDetail ?? []
      );
    } catch (error) {
      console.error(
        "Error fetching Customer Repayment report!",
        error?.response?.data?.Message
      );
    }
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => a.Name?.length - b.Name?.length,
    },
    {
      title: "BillDate",
      dataIndex: "billDate",
      sorter: (a, b) => a.Percentage?.length - b.Percentage?.length,
    },
    {
      title: "Bill No",
      dataIndex: "billNo",
      sorter: (a, b) => a.Percentage?.length - b.Percentage?.length,
    },

    {
      title: "RefNo",
      dataIndex: "refNo",
      sorter: (a, b) => a.Percentage?.length - b.Percentage?.length,
    },
    {
      title: "Customer",
      dataIndex: "customer",
      render: (customer) => customer?.name,
      sorter: (a, b) => a.customer?.name?.length - b.customer?.name?.length,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => a.Percentage?.length - b.Percentage?.length,
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Customer Repayment</h4>
              </div>
            </div>
            <ul className="table-top-head"></ul>
            <div className="d-flex purchase-pg-btn">
              <div className="page-btn"></div>
              <div className="page-btn import">
                <Link
                  to="#"
                  className="btn btn-added color"
                  data-bs-toggle="modal"
                  data-bs-target="#view-notes"
                >
                  <RefreshCw className="me-2" />
                  Refresh
                </Link>
              </div>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              {/* /Filter */}

              {/* /Filter */}
              <div className="table-responsive product-list">
                <Table columns={columns} dataSource={customerRepaymentData} />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
      <Pagination />
    </div>
  );
}

export default CustomerRepayment;
